var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtvShawStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7466_3454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.10047 10.4054C9.10047 12.5022 7.56102 13.7796 4.44875 13.7796H4.41537C2.57552 13.7796 1.10283 13.1899 1.03608 13.1572C0.768038 13.0583 0.5 12.9276 0.5 12.5675V11.29C0.5 11.0278 0.667903 10.8646 1.0027 10.9625C1.53776 11.0931 2.90931 11.6502 4.382 11.6502C5.78793 11.6502 6.42313 11.2574 6.42313 10.5361C6.42313 9.88101 5.85469 9.39023 4.14835 8.8658C1.77242 8.14545 0.701281 7.16289 0.701281 5.42634C0.701281 3.0684 2.74241 2.2491 4.68341 2.2491C5.95482 2.2491 6.9592 2.41335 7.76231 2.67557C8.13048 2.77353 8.19723 3.00309 8.19723 3.23166V4.34582C8.19723 4.60804 8.02933 4.7713 7.69454 4.706C7.25961 4.60804 5.95482 4.31317 4.98483 4.31317C3.94707 4.31317 3.34525 4.60804 3.34525 5.23042C3.34525 5.85281 3.64565 6.21298 5.55327 6.80272C7.52765 7.42511 9.06709 8.1128 9.10047 10.4054Z",
    fill: "#0082BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.489 8.03462C15.489 11.5394 13.4812 14.3891 10.7037 15.8634C10.5692 15.9287 10.4023 15.9941 10.2688 15.9941C10.0341 15.9941 9.90063 15.8308 9.90063 15.5686V13.8983C9.90063 13.6688 9.96739 13.5372 10.1009 13.4392C10.1009 13.4392 10.1677 13.4065 10.2344 13.3412C12.0419 12.1618 13.113 10.2946 13.113 8.00197C13.113 5.70933 12.0419 3.87482 10.2344 2.6627C10.1343 2.5974 10.1009 2.56474 10.1009 2.56474C9.96739 2.43314 9.90063 2.33518 9.90063 2.10562V0.435367C9.90063 0.173153 10.0341 0.0098877 10.2688 0.0098877C10.4357 0.0098877 10.6026 0.0751938 10.7037 0.1405C13.5146 1.58218 15.489 4.4319 15.489 8.03462Z",
    fill: "#0082BB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7466_3454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtvShawStore);
export default __webpack_public_path__ + "static/media/ctv_shaw_store.9dcc01ba23f275750b41615010a9b0c8.svg";
export { ForwardRef as ReactComponent };